module.exports = __webpack_public_path__ + "static/c4_image-466bfd42f363781c0b565730da33f71b.png";